/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCalendarEvent/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCalendarEvent({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCalendarEvent",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "#bc2323",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCalendarEvent.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZEy3ug': alignSelf,'--mt-2-ZEy3ug': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZEy3ug': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZEy3ug': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZEy3ug': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZEy3ug': opacity,'--w-10-ZEy3ug': typeof width === 'number' ? `${width}px` : width,'--h-11-ZEy3ug': typeof height === 'number' ? `${height}px` : height,'--f-12-ZEy3ug': fill,'--a-7-ZEy3ug': isAnimated ? animation : "none",'--sd-8-ZEy3ug': isAnimated ? strokeDashoffset : 0,'--sd-9-ZEy3ug': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconCalendarEvent.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_16546_27957)"
 className="views-block"
>
<path
  data-testid="TysiaIconCalendarEvent.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.5 0a1 1 0 011 1v1h5V1a1 1 0 112 0v1h1A1.5 1.5 0 0114 3.5v9a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 12.5v-9A1.5 1.5 0 011.5 2h1V1a1 1 0 011-1zM3 5.75a.25.25 0 00-.25.25v3c0 .138.112.25.25.25h3A.25.25 0 006.25 9V6A.25.25 0 006 5.75H3z"
 className="views-block"
/>
</g>
</svg>
{children}
</React.Fragment>)
}